var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76868 0.861888C4.8937 0.736864 5.06327 0.666626 5.24008 0.666626H10.7601C10.9369 0.666626 11.1065 0.736864 11.2315 0.861888L15.1382 4.76855C15.2632 4.89358 15.3334 5.06315 15.3334 5.23996V10.76C15.3334 10.9368 15.2632 11.1063 15.1382 11.2314L11.2315 15.138C11.1065 15.2631 10.9369 15.3333 10.7601 15.3333H5.24008C5.06327 15.3333 4.8937 15.2631 4.76868 15.138L0.86201 11.2314C0.736986 11.1063 0.666748 10.9368 0.666748 10.76V5.23996C0.666748 5.06315 0.736986 4.89358 0.86201 4.76855L4.76868 0.861888ZM5.51622 1.99996L2.00008 5.5161V10.4838L5.51622 14H10.4839L14.0001 10.4838V5.5161L10.4839 1.99996H5.51622Z",
    fill: "#5B6885"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.48375c8a.svg";
export { ForwardRef as ReactComponent };